import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { apps, SUPPORT_EMAIL } from '../data/apps';
import './Apps.css';

const statusLabel = (app) => {
  if (app.status === 'available') return 'Available';
  if (app.status === 'coming-soon') return 'Coming soon';
  return null;
};

export const AppIcon = ({ app, size = 72 }) => {
  const style = { width: size, height: size, borderRadius: size * 0.22 };
  if (app.icon) {
    return <img src={app.icon} alt="" className="app-icon" style={style} />;
  }
  const initials = app.name.split(/\s+/).map((w) => w[0]).join('').slice(0, 3).toUpperCase();
  return (
    <div className="app-icon app-icon-initials" style={{ ...style, background: app.accent || '#2c3e50', fontSize: size * 0.34 }} aria-hidden="true">
      {initials}
    </div>
  );
};

const Apps = () => {
  useEffect(() => {
    document.title = 'Apps — SVT Consulting';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="apps-page">
      <section className="apps-hero">
        <div className="container">
          <p className="apps-eyebrow">Software by SVT Consulting</p>
          <h1>Our apps</h1>
          <p className="apps-lede">
            Small, focused apps we design and build ourselves. Each one has its own privacy policy
            and support page — no app shares another's.
          </p>
        </div>
      </section>

      <section className="apps-grid-section">
        <div className="container">
          <div className="apps-grid">
            {apps.map((app) => {
              const hosted = Boolean(app.privacy);
              const label = statusLabel(app);
              const card = (
                <>
                  <div className="app-card-top">
                    <AppIcon app={app} />
                    {label && <span className={`app-status app-status-${app.status}`}>{label}</span>}
                  </div>
                  <h3>{app.name}</h3>
                  <p className="app-tagline">{app.tagline}</p>
                  <p className="app-platforms">{app.platforms.join(' · ')}</p>
                </>
              );
              return (
                <article className="app-card" key={app.slug}>
                  {hosted ? (
                    <Link to={`/apps/${app.slug}`} className="app-card-link">{card}</Link>
                  ) : app.site ? (
                    <a href={app.site} className="app-card-link" target="_blank" rel="noopener noreferrer">{card}</a>
                  ) : (
                    <div className="app-card-link">{card}</div>
                  )}
                  <div className="app-card-links">
                    {hosted ? (
                      <>
                        <Link to={`/apps/${app.slug}/privacy`}>Privacy</Link>
                        <Link to={`/apps/${app.slug}/support`}>Support</Link>
                        <Link to={`/apps/${app.slug}/terms`}>Terms</Link>
                      </>
                    ) : app.site ? (
                      <a href={app.site} target="_blank" rel="noopener noreferrer">Visit website ↗</a>
                    ) : (
                      <span className="app-card-muted">In development</span>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
          <p className="apps-support-line">
            Support for any of our apps: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Apps;
